<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import { getFirestore, collection, addDoc, serverTimestamp, updateDoc, doc  } from "firebase/firestore/lite"
import {firebase} from "../../../../../firebase-int";
import CryptoJS from 'crypto-js';
import { getStorage, ref, uploadBytesResumable, getDownloadURL,uploadBytes } from "firebase/storage";

const firestore = getFirestore(firebase);
const storage = getStorage(firebase);
import {
  required,
  minLength,
  url,
  requiredIf
} from 'vuelidate/lib/validators'

const mustHaveTo = (value) => (value + '').indexOf(' to ') >= 0

export default {
  page: {
    title: 'Edit Training',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage:'',
      successStatus:true,
      processingData:false,
      isUploading:false,
      totalSize:0,
      currentSize:0,

      pvtData: "",
      secret: "123#$%",
      encData: "",

      title: 'Edit Training',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Training',
          href: '/Training',
        },
        {
          text: 'Edit Training: '+this.$route.params.training.id,
          active: true,
        },
      ],
      form: {
        title: this.$route.params.training.title,
        description: this.$route.params.training.description,
        venue: this.$route.params.training.venue,
        dateValue: this.$route.params.training.date,
        fromDate: this.$route.params.training.fromDate,
        toDate: this.$route.params.training.toDate,
        trainingMode: this.$route.params.training.trainingMode,
        contentLink: this.$route.params.training.contentLink,
        trainingModes: ['Offline', 'Online'],
      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      
      calendarConfig: {
        wrap: true,
        defaultDate: new Date(),
        dateFormat: 'd/m/Y h:i K',
        mode: 'range',
        minDate: 'today',
        altInput: true,
        altFormat: 'F j, Y h:i K',
        time_24hr: false,
        enableTime: true,
      },
    }
  },
  validations: {
    form: {
      title: { required, minLength: minLength(2) },
      description: { required, minLength: minLength(5) },
      venue: { required, minLength: minLength(2) },
      dateValue: { required, mustHaveTo },
      contentLink: {
        required: requiredIf(function (value) {
          return (this.form.trainingMode=='Online')
        }),
        url,
      },
    },
  },
  methods: {
    async handleSubmit(e) {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      // await this.uploadFiles()
      this.updateTraining()
    },
  
    async updateTraining() {
      this.processingData=true;
      var index = this.form.dateValue.indexOf(' to ')
      if (index >= 0) {
        //valid
        this.form.fromDate = this.form.dateValue.substring(0, index)
        this.form.toDate = this.form.dateValue.substring(
          index + 4,
          this.form.dateValue.length
        )
      }
      console.log(
        '>>>>>> From Date: ' +
          this.form.fromDate +
          ' | toDate: ' +
          this.form.toDate
      )
      try {
        
            const docRef=doc(firestore, 'training', this.$route.params.training.id)
            await updateDoc(docRef, {
              title: this.form.title,
              description:this.form.description,
              venue: this.form.venue,
              date: this.form.dateValue,
              fromDate: this.form.fromDate,
              toDate: this.form.toDate,
              trainingMode: this.form.trainingMode,
              contentLink: this.form.contentLink,
              //created: serverTimestamp(),
              updated: serverTimestamp(),
              //createdBy: this.$store.state.auth.currentUser.id,
              updatedBy: this.$store.state.auth.currentUser.id,
            });
            //this.makeToast(false, "Document written with ID: ", docRef.id);
            this.successStatus=true;
            this.dismissSecs=2;
            this.alertMessage=this.$i18n.t('page.training.contentUpdatedMessage')+ docRef.id;
            this.showAlert();
            console.log("Document written with ID: ", docRef.id);
            await this.addToLog('training updated', this.$store.state.auth.currentUser.id , docRef.id);
            //this.clearFields();
            setTimeout(() => {
              this.$router.push({ name: 'Training' })
            }, 2000)
          } catch (e) {
            console.error("Error updating document: ", e);
            this.successStatus=false;
            this.dismissSecs=4;
            this.alertMessage=this.$i18n.t('page.training.unableToUpdate');
            this.showAlert();
            this.processingData=false;
          }
          //this.processingData=false;

      },

      // alert related methods
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },

      // encryption related methods
      encryptData(passwordData) {
        // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
        return CryptoJS.AES.encrypt(passwordData, this.secret).toString();
      },

      gotoTrainings()
      {
        this.$router.push({ name: 'Training', params: { userId: '123' } });
      },
      
  },
  mounted()
  {
    
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="$t('page.training.titleEdit')" />
    <div class="row">
      <div class="col-lg-12">
        <b-alert
          v-if="successStatus"
          :show="dismissCountDown"
          dismissible
          fade
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
        <b-alert
          v-else
          :show="dismissCountDown"
          dismissible
          fade
          variant="danger"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.training.basicTrainingInformation') }}</h4>
            <p class="sub-header">{{ $t('page.training.trainingInformation') }}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="title" :class="this.getStyle()">
                  {{ $t('page.training.labelTitle') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="title"
                  v-model="form.title"
                  name="title"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.title.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.title.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.title.required"
                    >{{ $t('page.training.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.title.minLength"
                    >{{ $t('page.training.mustBeTwoLong') }}</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label :class="this.getStyle()">
                  {{ $t('page.training.labelDescription') }}
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.description"
                  type="text"
                  rows="5"
                  name="description"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.description.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.description.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.description.required"
                    >{{ $t('page.training.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.description.minLength"
                    >{{ $t('page.training.bodyWarning') }}</span
                  >
                </div>
              </div>

              <div class="form-group mb-3">
                <label
                   :class="this.getStyle()"
                  >{{ $t('page.training.labelDate') }}
                  <span class="text-danger">*</span> ({{ $t('page.training.currentDate') }}: {{form.dateValue}})
                </label>
                <flat-pickr
                  v-model="form.dateValue"
                  :config="calendarConfig"
                  class="form-control"
                  placeholder="Date"
                  name="dateValue"
                  :class="{
                    'is-invalid': submitted && $v.form.dateValue.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && $v.form.dateValue.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.dateValue.required"
                    >{{ $t('page.training.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.dateValue.mustHaveTo"
                    >{{ $t('page.training.appropriateDate') }}</span
                  >
                </div>
              </div>

              <div class="form-group">
                <label for="default" :class="this.getStyle()">{{ $t('page.training.trainingMode') }}</label>
                <multiselect
                  v-model="form.trainingMode"
                  :options="form.trainingModes"
                  :allow-empty="false"
                ></multiselect>
              </div>

              <div v-if="form.trainingMode == 'Offline'" class="form-group">
                <label :class="this.getStyle()">
                  {{ $t('page.training.trainingVenue') }}
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.venue"
                  type="text"
                  rows="5"
                  name="venue"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.venue.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.venue.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.venue.required"
                    >{{ $t('page.training.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.venue.minLength"
                    >{{ $t('page.training.mustBeTwoLongVenue') }}</span
                  >
                </div>
              </div>

              <div v-if="form.trainingMode == 'Online'" class="form-group">
                <label for="contentLink" :class="this.getStyle()">
                  {{ $t('page.training.trainingContentLink') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="contentLink"
                  v-model="form.contentLink"
                  name="contentLink"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.contentLink.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.contentLink.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.contentLink.required"
                    >{{ $t('page.training.errorValueRequired') }}</span
                  >
                  <span v-if="!$v.form.contentLink.url"
                    >{{ $t('page.training.enterValidUrl') }}</span
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
              <template>
                <b-button
                  :disabled="processingData"
                  type="submit"
                  variant="primary"
                  ><i class="uil uil-down-arrow m1-1"></i>{{ $t('page.training.updateContentDetails') }}</b-button
                >

                <b-button
                  variant="light"
                  @click="gotoTrainings"
                  style="margin-left: 10px"
                  >{{ $t('page.training.close') }}</b-button
                >
              </template>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>
